import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import colors from 'vuetify/lib/util/colors'
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify);

export default new Vuetify({
	theme: {
    	dark: true,
    	light: false,   
  	},
  	icons: {
    	iconfont: 'mdi', // default - only for display purposes
  	},
});
